export default __webpack_public_path__ + "static/media/gold-plated-bangles-1.b5d94d57.jpg";